module.exports = __webpack_public_path__ + "static/media/HCMM071.b5d53392.jpg";